import * as React from "react";
import { Form, useFormikContext } from "formik";

import { ConfirmField } from "affinityForm/fields";
import { Button } from "affinityUI/elements/button";
import { Grid } from "affinityUI/elements/grid";

export const PasswordForm: React.FC = () => {
  const { isValid, isValidating } = useFormikContext();
  return (
    <Form>
      <Grid $tight>
        <p>In order to protect your password, make sure it:</p>
        <ul>
          <li>Is a minimum of 8 characters long.</li>
          <li>Contains at least 1 number.</li>
          <li>Is a mixture of both uppercase and lowercase letters.</li>
          <li>Contains at least 1 symbol.</li>
          <li>Is not a common password.</li>
        </ul>
        <ConfirmField plain name="password" confirmLabel="Confirm password" type="password">
          New password
        </ConfirmField>
        <Button type="submit" disabled={!isValid || isValidating}>
          Set password
        </Button>
      </Grid>
    </Form>
  );
};
